export const sedimentAnalysis = (data) => {

    let result = {
        sediment: {
            title: 'sediment accumulation',
            variables: 'vertical & horizontal',
        },
        highDel: {
            title: 'high marsh sediment delivery',
            variables: 'vertical & hydrology'
        },
        highInteg: {
            title: 'high marsh integrity',
            variables: 'vertical & biology'
        },
        lowDel: {
            title: 'low marsh sediment delivery',
            variables: 'horizontal & hydrology'
        },
        lowInteg: {
            title: 'low marsh/shoreline integrity',
            variables: 'horizontal & biology'
        },
        accumulation: {
            title: 'accumulation resistance',
            variables: 'hydrology & biology'
        }
    }
    

    // sediment
    result.sediment.score = [data.vertsed.currentConcern, data.horsed.currentConcern]
    let sedimentTest = JSON.stringify(result.sediment.score)
    
    sedimentTest === '[1,1]' ? result.sediment.consid = 'Poor platform & low marsh building' 
    : sedimentTest === '[1,0]' ? result.sediment.consid = 'Building concentrated in low marsh'
    : sedimentTest === '[0,1]' ? result.sediment.consid = 'Building concentrated on platform'
    : sedimentTest === '[0,0]' ? result.sediment.consid = 'Good platform & low marsh building'
    : result.sediment.consid = 'Need more information'
    
    // highDel
    result.highDel.score = [data.vertsed.currentConcern, data.hydrosed.currentConcern]
    let highDelTest = JSON.stringify(result.highDel.score)
    
    highDelTest === '[1,1]' ? result.highDel.consid = 'Poor platform building & sedimentation potential' 
    : highDelTest === '[1,0]' ? result.highDel.consid = 'Investigate subsidence, surface accretion, & decomposition'
    : highDelTest === '[0,1]' ? result.highDel.consid = 'Platform building not sourced from TSS'
    : highDelTest === '[0,0]' ? result.highDel.consid = 'Good platform building & sedimentation potential'
    : result.highDel.consid = 'Need more information'

    // highInteg
    result.highInteg.score = [data.vertsed.currentConcern, data.biosed.currentConcern]
    let highIntegTest = JSON.stringify(result.highInteg.score)
    
    highIntegTest === '[1,1]' ? result.highInteg.consid = 'Poor  platform resilience' 
    : highIntegTest === '[1,0]' ? result.highInteg.consid = 'Investigate subsidence, surface accretion, & TSS'
    : highIntegTest === '[0,1]' ? result.highInteg.consid = 'Platform building but potentially soft/unstable'
    : highIntegTest === '[0,0]' ? result.highInteg.consid = 'Good platform resilience'
    : result.highInteg.consid = 'Need more information'

    // lowDel
    result.lowDel.score = [data.horsed.currentConcern, data.hydrosed.currentConcern]
    let lowDelTest = JSON.stringify(result.lowDel.score)
    
    lowDelTest === '[1,1]' ? result.lowDel.consid = 'Poor sediment delivery to low marsh' 
    : lowDelTest === '[1,0]' ? result.lowDel.consid = 'Investigate hydrodynamics & sediment trapping efficiency'
    : lowDelTest === '[0,1]' ? result.lowDel.consid = 'Low marsh building not sourced from TSS'
    : lowDelTest === '[0,0]' ? result.lowDel.consid = 'Good sediment delivery to low marsh'
    : result.lowDel.consid = 'Need more information'

    // lowInteg
    result.lowInteg.score = [data.horsed.currentConcern, data.biosed.currentConcern]
    let lowIntegTest = JSON.stringify(result.lowInteg.score)
    
    lowIntegTest === '[1,1]' ? result.lowInteg.consid = 'Poor low marsh resilience' 
    : lowIntegTest === '[1,0]' ? result.lowInteg.consid = 'Investigate hydrodynamics & sediment trapping efficiency'
    : lowIntegTest === '[0,1]' ? result.lowInteg.consid = 'Low marsh building but potentially soft/unstable'
    : lowIntegTest === '[0,0]' ? result.lowInteg.consid = 'Good low marsh resilience'
    : result.lowInteg.consid = 'Need more information'

    // accumulation
    result.accumulation.score = [data.hydrosed.currentConcern, data.biosed.currentConcern]
    let accumulationTest = JSON.stringify(result.accumulation.score)
    
    accumulationTest === '[1,1]' ? result.accumulation.consid = 'Poor H & V building potenitial' 
    : accumulationTest === '[1,0]' ? result.accumulation.consid = 'Investigate sediment trapping efficiency, surface accretion, & vegetation qualities'
    : accumulationTest === '[0,1]' ? result.accumulation.consid = 'Investigate source and composition of TSS'
    : accumulationTest === '[0,0]' ? result.accumulation.consid = 'Good H & V building potenitial'
    : result.accumulation.consid = 'Need more information'

   return result
}